import React from 'react';
import { S } from './ControlsFilters.styles';

type Props = {
  filterByClient: string;
  filterByProject: string;
  setFilterByClient: (value: string) => void;
  setFilterByProject: (value: string) => void;
};

export const ControlsFilters: React.FC<Props> = ({
  filterByClient,
  filterByProject,
  setFilterByClient,
  setFilterByProject,
}) => {
  const hasActiveFilters =
    filterByClient.trim().length > 0 || filterByProject.trim().length > 0;

  const clearFilters = () => {
    setFilterByClient('');
    setFilterByProject('');
  };

  return (
    <S.FiltersContainer>
      <S.SearchContainer>
        <S.Icon src="Search" height={16} width={16} color="darkGray" />
        <S.SearchInput
          placeholder="Sök uppdragsgivare"
          value={filterByClient}
          onChange={(e) => setFilterByClient(e.target.value)}
          aria-label="Filtrera på uppdragsgivare"
        />
        {filterByClient && (
          <S.ClearButton
            type="button"
            onClick={() => setFilterByClient('')}
            aria-label="Rensa uppdragsgivare"
          >
            <S.Icon src="Close" height={14} width={14} />
          </S.ClearButton>
        )}
      </S.SearchContainer>

      <S.SearchContainer>
        <S.Icon src="Search" height={16} width={16} color="darkGray" />
        <S.SearchInput
          placeholder="Sök projekt"
          value={filterByProject}
          onChange={(e) => setFilterByProject(e.target.value)}
          aria-label="Filtrera på projekt"
        />
        {filterByProject && (
          <S.ClearButton
            type="button"
            onClick={() => setFilterByProject('')}
            aria-label="Rensa projekt"
          >
            <S.Icon src="Close" height={14} width={14} />
          </S.ClearButton>
        )}
      </S.SearchContainer>

      {hasActiveFilters && (
        <S.ClearFiltersButton type="button" onClick={clearFilters}>
          Rensa filter
        </S.ClearFiltersButton>
      )}
    </S.FiltersContainer>
  );
};
